import { ArrowForward, CheckCircleOutlined, RadioButtonUnchecked } from '@mui/icons-material'
import { Box, Button, Card, Typography } from '@mui/material'
import { CARD_COLORS } from '../../../../utils/colors'
import { type PriorityActivity } from '../../../../models/PriorityActivity'

interface Props {
  handlePriorityContinue: () => void
  num: number
  title: string
  activities: PriorityActivity[]
}

export const PriorityCard = (props: Props): JSX.Element => {
  const lightCardColor = CARD_COLORS.light[props.num - 1 % CARD_COLORS.light.length]
  const cardColor = CARD_COLORS.dark[props.num - 1 % CARD_COLORS.dark.length]

  const priorityActivityIsStarted = props.activities.some(a => a.started)

  return <Card
    data-testid='priorityActivityCard'
    key={props.num}
    sx={{
      backgroundColor: lightCardColor,
      width: '225px',
      height: '500px',
      borderRadius: '12px',
      padding: '20px 27px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }}
  >
    <Box
      sx={{
        width: '115px',
        height: '115px',
        backgroundColor: cardColor,
        borderRadius: '12px',
        display: 'grid',
        placeContent: 'center',
        alignSelf: 'center'
      }}
    >
      <Typography variant='h1' sx={{ fontSize: '40px', fontVariantNumeric: 'lining-nums', color: 'white' }}>
        {props.num.toString().padStart(2, '0')}
      </Typography>
    </Box>

    <Typography variant='h4'>{props.title}</Typography>

    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}
    >
      {props.activities.map(a => (
        <Box key={a.name} sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {a.started
            ? <CheckCircleOutlined sx={{ color: 'var(--grey-900)' }} />
            : <RadioButtonUnchecked sx={{ color: 'var(--grey-900)' }} />}

          <Typography variant='body1'>{a.name}</Typography>
        </Box>
      ))}
    </Box>

    <Button
      data-testid='continueButton'
      onClick={props.handlePriorityContinue}
      sx={[{
        backgroundColor: 'var(--white)',
        color: 'var(--grey-700)',
        marginTop: 'auto',
        width: '230px',
        textTransform: 'none',
        py: '12px',
        px: '24px'
      },
      {
        '&:hover': {
          backgroundColor: lightCardColor
        }
      }]}
    >
      {priorityActivityIsStarted ? 'Continue' : 'Begin'} Priority <ArrowForward sx={{ ml: '10px' }} />
    </Button>
  </Card>
}
